/*
 * ChatAds Messages
 *
 * This contains all the text for the ChatAds component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header_top: {
    id: 'app.containers.ChatAds.header_top',
    defaultMessage: 'Konsultasi Hukum dengan Advokat Pilihan'
  },
  header_bottom: {
    id: 'app.containers.ChatAds.header_bottom',
    defaultMessage: 'Konsultasi Hukum dengan Advokat Pilihan'
  },
  header_waris: {
    id: 'app.containers.ChatAds.header_waris',
    defaultMessage: 'Mempunyai masalah waris?'
  },
  header_pesangon: {
    id: 'app.containers.ChatAds.header_pesangon',
    defaultMessage: 'Tidak mendapatkan hak pesangon Anda?'
  },
  header_piutang: {
    id: 'app.containers.ChatAds.header_piutang',
    defaultMessage: 'Piutang tidak tertagih?'
  },
  description_bottom: {
    id: 'app.containers.ChatAds.description_bottom',
    defaultMessage: '15.000+ masalah hukum telah dikonsultasikan bersama kami',
  },
  description_top: {
    id: 'app.containers.ChatAds.description_top',
    defaultMessage: '15.000+ masalah hukum telah dikonsultasikan bersama kami',
  },
  description_waris: {
    id: 'app.containers.ChatAds.description_waris',
    defaultMessage: 'Konsultan hukum bidang waris berpengalaman siap membantu.'
  },
  description_pesangon: {
    id: 'app.containers.ChatAds.description_pesangon',
    defaultMessage: 'Konsultan hukum bidang ketenagakerjaan berpengalaman siap membantu.'
  },
  description_piutang: {
    id: 'app.containers.ChatAds.description_piutang',
    defaultMessage: 'Konsultan hukum bidang hutang-piutang berpengalaman siap membantu.'
  },
  cta: {
    id: 'app.containers.ChatAds.cta',
    defaultMessage: 'Chat Sekarang'
  },
});
